import React from 'react';
import PropTypes from 'prop-types';
import { RichTextPropTypes } from '../../prop-types';
import iconSrc from '../../utils/iconSrc';
import { propLink } from '../link-handler';
import { CoveringLink } from '../styled/links';
import { VisuallyHidden } from '../styled/accessibility';
import { consistentString } from '../../utils/content-formatting';
import RichText from '../rich-text/base';

// Styles
import {
  Card,
  CardInner,
  TitleText,
  SubText,
  StyledCardCTA,
  CardSVG,
  SVGWrapper,
} from './styles';

const CardWithIcon = ({
  icon,
  titleText,
  subText,
  leftAlignContent,
  ctaText,
  link,
  ctaColor,
}) => (
  <Card data-testid="card-with-icon">
    <CardInner>
      {icon ? (
        <SVGWrapper>
          <CardSVG src={iconSrc(icon)} aria-hidden="true" cacheRequests />
        </SVGWrapper>
      ) : null}
      <TitleText data-testid="title-text">{titleText}</TitleText>
      {subText ? (
        <SubText $leftAlignContent={leftAlignContent}>
          <RichText richText={subText} />
        </SubText>
      ) : null}
      {link && ctaText ? (
        <>
          <StyledCardCTA
            link={link}
            bg={consistentString(ctaColor)}
            fullWidth
            dataTracking={icon}
            className="tracking-card-cta"
            data-testid="ctaText"
          >
            {ctaText}
          </StyledCardCTA>
          <span aria-hidden="true">
            <CoveringLink link={link} tabIndex="-1">
              <VisuallyHidden>{ctaText}</VisuallyHidden>
            </CoveringLink>
          </span>
        </>
      ) : null}
    </CardInner>
  </Card>
);

CardWithIcon.defaultProps = {
  ctaColor: 'Primary',
};

CardWithIcon.propTypes = {
  icon: PropTypes.oneOf([
    'Speech bubble',
    'Telephone',
    'Map Marker',
    'Open Book',
  ]),
  titleText: PropTypes.string.isRequired,
  subText: RichTextPropTypes,
  leftAlignContent: PropTypes.bool.isRequired,
  ctaText: PropTypes.string.isRequired,
  ctaColor: PropTypes.oneOf(['Primary', 'Secondary-Outline']),
  link: propLink,
};

export default CardWithIcon;
